import { ModelBase } from './model-base';
import { IUser } from './user';
import { IRole } from './role';

export enum AclAccess {
  ALLOW = 'allow',
  DENY = 'deny',
}

export interface IAcl extends ModelBase {
  roleId?: string;
  role?: IRole;
  userId?: string;
  user?: IUser;
  permission?: any;
  access?: AclAccess;
}
